<template>
  <div class="attendance-page">
    <div class="title">
      <button
        class="btn btn-default pull-right"
        @click="goToAcademyAttendance()"
      >
        {{ trans('definitions.application_name') }}
      </button>

      <h2>{{ trans('core.attendance') }} {{ trans_choice('core.mentor_students', 2) }}: {{ name }}</h2>
      <span v-safe-html="description" />
    </div>

    <table class="table">
      <tr>
        <th>
          <span class="first-th">{{ trans('core.student') }}</span>
        </th>
        <th>{{ trans('report.course.attended') }}</th>
        <th>{{ trans('subscription.subscribable_groupings.complied') }}</th>
      </tr>

      <template v-for="(student, student_index) in students">
        <tr
          :key="student_index"
          :class="{ 'trColor': student_index % 2 === 0 }"
        >
          <td
            class="click-open"
            @click="openOrCloseStudent(student.id)"
          >
            <span
              class="margin-left"
              :class="!studentIsOpened(student.id) ? 'fa fa-chevron-right' : 'fa fa-chevron-down'"
            /> {{ student.attributes.name }}
          </td>

          <td>
            {{ student.attributes.amount_attended }}
          </td>

          <td
            :class="checkComplied(student.attributes) ? 'check-background' : 'remove-background'"
          >
            <span :class="checkComplied(student.attributes) ? 'fa fa-check' : 'fa fa-remove'" />
          </td>
        </tr>

        <tr
          v-if="studentIsOpened(student.id)"
          :key="'details_' + student_index"
        >
          <template v-if="eventStudents.hasOwnProperty(student.id)">
            <td colspan="4">
              <table
                class="table table-small"
                style="background-color:inherit"
              >
                <tr class="tdWhite">
                  <th>{{ trans('core.class') }}</th>
                  <th>{{ trans('core.date') }}</th>
                  <th>{{ trans('core.group') }}</th>
                  <th>{{ trans('core.attended') }}</th>
                </tr>
                <tr
                  v-for="(event_student, event_student_index) in eventStudents[student.id]"
                  :key="'details_student_' + student_index + '_event_' + event_student_index"
                >
                  <td>{{ event_student.attributes.name }}</td>
                  <td>{{ event_student.attributes.datetime }}</td>
                  <td>{{ event_student.attributes.groups }}</td>
                  <td>
                    <span :class="event_student.attributes.attended ? 'fa fa-check' : 'fa fa-remove'" /> <span
                      v-if="event_student.attributes.attended && !event_student.attributes.should_attend"
                      class="should_not_attend fa fa-exclamation"
                      :title="trans('core.attended_outside_schedule')"
                    /> <span
                      v-else-if="!event_student.attributes.attended && event_student.attributes.excused"
                      class="should_not_attend fa fa-exclamation"
                      :title="trans('core.excused')"
                    /> <span
                      v-else-if="!event_student.attributes.attended && !event_student.attributes.attendance_registered"
                      class="should_not_attend fa fa-exclamation"
                      :title="trans('core.not_registered')"
                    />
                  </td>
                </tr>
              </table>
            </td>
          </template>
          <loader
            v-else
            class="loader"
          />
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
import { defaultErrorMessage } from '@/helpers'
import { orderBy } from 'lodash'
import Loader from '@/employees/components/Loader'

export default {

  name: 'AttendancePage',

  components: { Loader },

  props: {
    enddate: {
      required: true,
      type: String,
    },
    maximumAbsent: {
      required: true,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    startdate: {
      required: true,
      type: String,
    },
    token: {
      required: true,
      type: String,
    },
  },

  data () {
    return {
      students: null,
      studentIdsOpened: [],
      eventStudents: {},
    }
  },

  computed: {
    description () {
      return `${moment(this.startdate).format('DD-MM-YYYY')} ${Lang.get('time.till_short')} ${moment(this.enddate).format('DD-MM-YYYY')}
      &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;  ${Lang.get('attendances.maximum_absent')}: ${this.maximumAbsent}`
    },
  },

  created () {
    axios.get(`${this.token}/api`).then((response) => {
      this.students = _.orderBy(Object.values(response.data.data), 'attributes.sortName')
    }).catch(error => defaultErrorMessage(error))
  },

  methods: {
    checkComplied (student) {
      return student.amount_attended >= student.amount_should_attend - student.amount_excused - this.maximumAbsent
    },

    goToAcademyAttendance () {
      window.location = '/employee/dashboard'
    },

    openOrCloseStudent (studentId) {
      if (this.studentIsOpened(studentId)) {
        this.studentIdsOpened.splice(this.studentIdsOpened.indexOf(studentId), 1)
      } else {
        axios.get(`${this.token}/students/${studentId}`).then((response) => {
          Vue.set(this.eventStudents, studentId, _.orderBy(Object.values(response.data.data), 'attributes.starttime'))
          this.studentIdsOpened.push(studentId)
        }).catch(error => defaultErrorMessage(error))
      }
    },

    studentIsOpened (studentId) {
      return this.studentIdsOpened.includes(studentId)
    },
  },
}
</script>

<style>
    .attendance-page {
        background: white;
        margin-left: 5px;
        padding-left: 10px;
        margin-top: -60px;
        padding-top: 10px;
        padding-bottom: 60px;
        padding-right: 15px;
    }

    .title {
        margin-left: 20px;
    }

    .table {
        width: 100%;
        max-width: 100%;
        margin-bottom: 1rem;
        margin-top: 20px;
        border: 1px solid #eceeef;
    }

    .table-small {
        border: none;
        margin-left: 20px;
        width: 95% !important;
        margin-top: 5px;
        font-size: 13px;
    }

    .table th,
    .table td {
        padding: 0.75rem;
        vertical-align: top;
        border-top: 1px solid #eceeef;
    }

    .table-small th {
        border-top: none;
    }

    .trColor {
        background-color: #f9f9f9;
    }

    .tdWhite {
        background-color: white;
    }

    .check-background {
        background-color: darkseagreen;
    }

    .remove-background {
        background-color: lightcoral;
    }

    .click-open {
        cursor: pointer;
    }

    .first-th {
        padding-left: 5px;
    }

    .fa-chevron-right {
        margin-right: 5px;
    }

    .table-small .fa-check {
        color: green;
    }

    .table-small .fa-remove {
        color: red;
    }

    .btn {
        margin-right: 15px !important;
    }

  .loader {
    padding-bottom: 20px;
  }

  .should_not_attend {
    color: red;
  }
</style>
